/**
 * Permission modules and access control utilities
 */

export const PERMISSION_MODULES = [
  { key: "projects", label: "Projects" },
  { key: "financials", label: "Financials" },
  { key: "onedrive", label: "OneDrive / Files" },
  { key: "recordings", label: "Record" },
  { key: "automations", label: "AI Automations" },
  { key: "drawing_evaluation", label: "Drawing Evaluation" },
  { key: "integrations", label: "Integrations" },
  { key: "settings", label: "Settings" },
];

/**
 * Check if a user has access to a specific module
 * @param {Object} user - User object with role and permissions array
 * @param {string} moduleKey - Module key to check access for
 * @returns {boolean} True if user has access to the module
 */
export function hasModuleAccess(user, moduleKey) {
  if (!user) return false;
  
  const role = user.role;
  
  // Super admins and legacy admins always have access to everything
  if (role === "super_admin" || role === "admin") return true;
  
  const permissions = user.permissions || [];
  
  // Org admins can only access modules in their permissions array
  if (role === "org_admin") {
    return permissions.includes(moduleKey);
  }
  
  // Regular users: if permissions array is empty, show everything (backward compat)
  // If permissions array is non-empty, only show those modules (strict)
  if (permissions.length === 0) return true;
  return permissions.includes(moduleKey);
}
